import React from "react";
import { Typography } from "@material-ui/core";
import EmptyFilesIcon from "src/pages/ServiceOrdersDetails/components/icons/EmptyFilesIcon";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(2),
  },
  icon: {
    width: 100,
    height: 100,
    marginTop: 20,
    marginBottom: 16,
  },
  title: {
    padding: theme.spacing(2),
  },
}));
const NoFiles = () => {
  const classes = useStyles();
  const { t } = useTranslation("orders");
  return (
    <div className={classes.wrapper}>
      <EmptyFilesIcon className={classes.icon} />
      <Typography variant="h3" className={classes.title}>
        {t("labels.files.empty")}
      </Typography>
    </div>
  );
};

export default NoFiles;
